import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import InstitutionCourseCard from "./institutionCourseCard";
import "../../styles/admin/institutionCourse.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import EmptyPage from "../common/emptyPage";

import {
  createInstitutionCourse,
  getAllInstitutionCourse,
  getAllNotInInstitutionCourse,
  updateInstitutionCourse,
} from "../../helper/apicalls/institution";
import CourseSelectForm from "./CourseSelectForm";
import GlobalLoader from "../common/GlobalLoader";
import SuccessPopup from "../common/SuccessPopup";

const InstitutionCourse = ({ searchQuery }) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const role = Cookies.get("role");
  const authToken = Cookies.get("admin_token");
  const navigate = useNavigate();
  const [institutionCourseData, setInstitutionCourseData] = useState([]);
  const [isCourseFormOpen, setIsCourseFormOpen] = useState(false);
  const [notInInstitutionCourse, setNotInInstitutionCourse] = useState([]);
  const [institutionCourse, setInstitutionCourse] = useState([]);
  const [successOpen, setSuccessOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [popupType, setPopupType] = useState("success");
  const [loader, setLoader] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const handleCourseClick = (courseId) => {
    navigate(
      `/admin/institution/course/info?institution=${id}&course=${courseId?.key}`,
      { state: { courseName: courseId?.name } }
    );
  };

  const handleMenuClick = (e, courseId) => {
    e.stopPropagation();
  };

  const fetchInstitutionCourse = async () => {
    setLoader(true);
    try {
      const params = {};
      if (debouncedSearch.trim()) params.search = debouncedSearch.trim();
      const res = await getAllInstitutionCourse(authToken, id, params);
      setInstitutionCourse(res || []);
      setInstitutionCourseData(res[0]?.course || []);
    } catch (err) {
      console.error("Failed to fetch institution courses:", err);
    } finally {
      setLoader(false);
    }
  };

  const fetchNotInInstitutionCourse = async () => {
    try {
      const res = await getAllNotInInstitutionCourse(authToken, id);
      setNotInInstitutionCourse(res || []);
    } catch (err) {
      console.error("Failed to fetch available courses:", err);
    } finally {
    }
  };

  const handleSelectFormSubmit = async (payload) => {
    setLoader(true);

    if (institutionCourse?.length === 0) {
      try {
        const res = await createInstitutionCourse(authToken, {
          institution: id,
          course_keys: payload?.courseIds,
        });
        setSuccessMsg(res?.message || "Courses added successfully");
        setPopupType("success");
        setSuccessOpen(true);
        setIsCourseFormOpen(false);
        await fetchInstitutionCourse();
        await fetchNotInInstitutionCourse();
      } catch (err) {
        console.error("Failed to create institution courses:", err);
        setSuccessMsg(err?.message || "Failed to add courses");
        setPopupType("error");
        setSuccessOpen(true);
      } finally {
        setLoader(false);
      }
    } else {
      try {
        const res = await updateInstitutionCourse(
          authToken,
          institutionCourse[0]?.id,
          { course_keys: payload?.courseIds }
        );
        setSuccessMsg(res?.message || "Courses added successfully");
        setPopupType("success");
        setSuccessOpen(true);
        setIsCourseFormOpen(false);
        await fetchInstitutionCourse();
        await fetchNotInInstitutionCourse();
      } catch (err) {
        console.error("Failed to update institution courses:", err);
        setSuccessMsg(err?.message || "Failed to update courses");
        setPopupType("error");
        setSuccessOpen(true);
      } finally {
        setLoader(false);
      }
    }
  };

  useEffect(() => {
    fetchNotInInstitutionCourse();
    return () => {};
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchQuery), 300);
    return () => clearTimeout(t);
  }, [searchQuery]);

  useEffect(() => {
    fetchInstitutionCourse();
  }, [debouncedSearch]);

  return (
    <Box className="course-container">
      {loader && <GlobalLoader visible={loader} text="Loading courses..." />}
      <div className="course-header">
        <h4 className="section-title">Courses List</h4>

        <button
          className="course-create-btn btn-interactive"
          type="button"
          onClick={() => setIsCourseFormOpen(true)}
        >
          Add Course
        </button>
      </div>
      {Array.isArray(institutionCourseData) &&
      institutionCourseData.length > 0 ? (
        <Box className="course-grid">
          {institutionCourseData.map((course) => (
            <InstitutionCourseCard
              key={course.id}
              course={course}
              onClick={handleCourseClick}
              onMenuClick={handleMenuClick}
              hideMenuIcon={true}
            />
          ))}
        </Box>
      ) : (
        <EmptyPage content={"No courses Available"} />
      )}

      {isCourseFormOpen && (
        <CourseSelectForm
          isOpen={isCourseFormOpen}
          onClose={() => setIsCourseFormOpen(false)}
          onSubmit={handleSelectFormSubmit}
          courses={notInInstitutionCourse}
          title="Add Courses"
        />
      )}
      {successOpen && (
        <SuccessPopup
          open={successOpen}
          onClose={() => setSuccessOpen(false)}
          message={successMsg}
          type={popupType}
        />
      )}
    </Box>
  );
};

export default InstitutionCourse;
